export class Utilities {
  public static escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  public static replaceAll(str: string, find: string, replace: string): string {
    return (str || '').replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
  }

  public static isValidUuid(uuid: string): boolean {
    const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
    const isValid = regexExp.test(uuid);
    return isValid;
  }
}
